import { SEO, createArticleSchema, createBreadcrumbSchema } from "@/components/SEO";
import { getInsightBySlug } from "@/data/insights";
import { getInsightFAQSchema } from "@/data/insightFAQs";

interface InsightSEOProps {
  slug: string;
  additionalKeywords?: string[];
}

export const InsightSEO = ({ slug, additionalKeywords = [] }: InsightSEOProps) => {
  const insight = getInsightBySlug(slug);
  
  if (!insight) return null;

  const articleSchema = createArticleSchema({
    title: insight.title,
    description: insight.description,
    url: `/insights/${insight.slug}`,
    publishedTime: insight.publishedDate,
    section: insight.tag,
  });

  const breadcrumbSchema = createBreadcrumbSchema([
    { name: "Home", url: "/" },
    { name: "Insights", url: "/" },
    { name: insight.tag, url: `/?category=${encodeURIComponent(insight.tag)}` },
    { name: insight.title, url: `/insights/${insight.slug}` },
  ]);

  // Get FAQ schema if available for this insight (great for GEO)
  const faqSchema = getInsightFAQSchema(slug);

  const defaultKeywords = [
    insight.tag.toLowerCase(),
    "email deliverability",
    "IT Dukes",
    ...insight.title.toLowerCase().split(" ").filter(w => w.length > 3),
  ];

  // Combine all schemas
  const schemas: Record<string, any>[] = [articleSchema, breadcrumbSchema];
  if (faqSchema) {
    schemas.push(faqSchema);
  }

  return (
    <SEO
      title={insight.title}
      description={insight.description}
      canonical={`/insights/${insight.slug}`}
      type="article"
      publishedTime={insight.publishedDate}
      section={insight.tag}
      keywords={[...defaultKeywords, ...additionalKeywords]}
      jsonLd={schemas}
    />
  );
};

// Simple component export for ease of use
export default InsightSEO;
